import {NgModule} from '@angular/core';
import {DragDropModule} from '@angular/cdk/drag-drop';

import {SharedModule} from '@shared';

import {TaskFeasibilityInfoModule} from 'planner-shared';

import {EmployeeComponent} from './employee.component';
import {EmployeeListComponent} from './list/employee-list.component';
import {EmployeeEditComponent} from './edit/employee-edit.component';
import {EmployeeAssignedTasksComponent} from './tasks/assigned/employee-assigned-tasks.component';
import {EmployeeUnassignedTasksComponent} from './tasks/unassigned/employee-unassigned-tasks.component';
import {EmployeeInfoComponent} from './info/employee-info.component';
import {EmployeeTaskFeasibilityInfoComponent} from './tasks/feasibility-info/employee-task-feasibility-info.component';
import {AdminTaskModalComponent} from './tasks/admin-task-modal/admin-task-modal.component';
import {FormInputAutocompleteModule} from "../../../_shared/form-input-autocomplete/form-input-autocomplete.module";
import {EmployeeAssignedTaskEditComponent} from './tasks/assigned/edit/employee-assigned-task-edit.component';
import {EmployeeUnassignedTasksEditComponent} from './tasks/unassigned/edit/employee-unassigned-tasks-edit.component';
import {ShiftSplitModalComponent} from './shift-split-modal/shift-split-modal.component';
import {
    CompetenceUpdateModalComponent
} from './tasks/unassigned/edit/competence-update-modal/competence-update-modal.component';
import {RosterUpdateModalComponent} from './roster-update-modal/roster-update-modal.component';

@NgModule({
    declarations: [
        EmployeeComponent,
        EmployeeListComponent,
        EmployeeEditComponent,
        EmployeeInfoComponent,
        EmployeeAssignedTasksComponent,
        EmployeeUnassignedTasksComponent,
        EmployeeTaskFeasibilityInfoComponent,
        AdminTaskModalComponent,
        EmployeeAssignedTaskEditComponent,
        EmployeeUnassignedTasksEditComponent,
        ShiftSplitModalComponent,
        CompetenceUpdateModalComponent,
        RosterUpdateModalComponent
    ],
    imports: [SharedModule, DragDropModule, TaskFeasibilityInfoModule, FormInputAutocompleteModule]
})
export class EmployeesModule {
}
